import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';
import { Observable, of } from 'rxjs';
import { environment } from '../../environments/environment';
import { AppStateService } from './app-state.service';



@Injectable()
export class BaseService {

  protected apiUrl: string;
  protected serverUrl: string;

  protected readonly httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Accept': 'application/json' })
  };

  constructor(protected http: HttpClient, protected messageService: MessageService, protected appState: AppStateService) {
    this.apiUrl = environment.apiURL.replace(/\/$/g, '');
    this.serverUrl = environment.serverURL.replace(/\/$/g, '');
    // this.loggedOut$ = new BehaviorSubject(false);
  }

  /**
   * Handle Http operation that failed.
   * Let the app continue.
   * @param operation - name of the operation that failed
   * @param result - optional value to return as the observable result
   */
  protected handleError<T>(operation = 'operation', result?: T, summary = 'Fehler') {
    return (error: HttpErrorResponse): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // TODO: better job of transforming error for user consumption
      this.log(`${operation} failed: ${error.status}`);
      this.log(`${operation} failed: ${error.message}`);
      this.log(`${operation} failed: ${error.error.message}`);
      this.log(`${operation} failed: ${JSON.stringify(error.error.errors)}`);
      let msgDetail = `${operation} failed: ${JSON.stringify(error.message)}`;
      if (error.status === 401) {
        this.appState.forceLogout = true;
        msgDetail = 'Ihre Anmeldung ist abgelaufen. Bitte melden Sie sich erneut an!';
        console.log(msgDetail);
      }

      this.messageService.add({
        severity: 'error',
        summary: summary,
        detail: msgDetail
      });

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

  /** Log a message with the LoggingService */
  // TODO: create loggin service and log error stuff at the server
  protected log(message: string) {
    console.log(message);
  }

}
